import { absoluteApiFilePreviewUrl } from './api'

/** 전산 표시명 ↔ orgs.name 매칭용 (공백·대소문자 무시) */
export function normalizeInsurerKey(name) {
  return String(name || '').trim().replace(/\s+/g, '').toLowerCase()
}

/**
 * 보험사 전산 표의 회사명(displayName)과 동일한 이름의 INSURER 조직을 찾아
 * 청구 브랜드 로고(있으면) 또는 logoFileId 미리보기 URL을 반환합니다.
 * @param {string} displayName insurerSystemsData 행의 name (예: 삼성화재)
 * @param {Array<object>} orgOptions GET /orgs/options 응답 배열
 * @returns {string|null}
 */
export function resolveInsurerLogoUrlFromOrgOptions(displayName, orgOptions) {
  if (!displayName || !Array.isArray(orgOptions)) return null
  const key = normalizeInsurerKey(displayName)
  const insurers = orgOptions.filter((o) => o && String(o.type) === 'INSURER')
  const match = insurers.find((o) => normalizeInsurerKey(o.name) === key)
  if (!match) return null
  const fid = match.claimBrandLogoFileId || match.logoFileId
  if (!fid) return null
  return absoluteApiFilePreviewUrl(fid)
}
